// extracted by mini-css-extract-plugin
export default {"backIcon":"BackLink_backIcon__ey4c+","backLink":"BackLink_backLink__LI3fN","backLinkGrey":"BackLink_backLinkGrey__TSC-2"};